/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DirectoryAttributeOption = {
  /**
   * Directory attribute key, e.g. department_name.
   */
  key: string;
  /**
   * Number of directory users with this value.
   */
  memberCount: number;
  /**
   * Directory attribute value.
   */
  value: string;
};

/** @internal */
export const DirectoryAttributeOption$inboundSchema: z.ZodMiniType<
  DirectoryAttributeOption,
  unknown
> = z.pipe(
  z.object({
    key: z.string(),
    member_count: z.int(),
    value: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "member_count": "memberCount",
    });
  }),
);

export function directoryAttributeOptionFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryAttributeOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryAttributeOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryAttributeOption' from JSON`,
  );
}
